import { useModalState } from '@olo-web/client-state';
import { EModalTypes } from '@olo-web/types/enums';

export const useIsStartATabModal = () => {
  const modalState = useModalState();

  return modalState?.modalKey === EModalTypes.START_A_TAB;
};
